{
  "id": "osiris",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Osíris",
    "en": "Osiris"
  },
  "icon": "gods/osiris",
  "portrait": "gods/osiris-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "mummy": 1
  },
  "unlocks": ["mummy", "new-kingdom", "atef-crown", "desert-wind", "pharaoh-new-kingdom"],
  "powers": ["son-of-osiris"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "God of life and resurrection. Focus: Camel Riders and Pharaohs. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 240 s."
  }
}
